import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useStaticOptions } from "../context/StaticOptionsContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useOrderSave } from "../context/OrderSaveContext";
import { showErrorToast } from "../components/toasts/ToastService";

const TalpSarok = () => {
	const { order, updateOrder } = useOrder();
	const navigate = useStepNavigate();
	const [selectedTalpId, setSelectedTalpId] = useState(order.hmeliorder?.hmeliorder_cornertype_id || null);
	const [sarokMagassag, setSarokMagassag] = useState(order.hmeliorder?.hmeliorder_corner_height || null);
	const { saveOrder } = useOrderSave();
	const [loading, setLoading] = useState(false);
	const { staticOptions } = useStaticOptions();
	
	const corner_types = order.model_options?.corner_types_for_model || [];
	const corner_heights = order.model_options?.corner_heights_for_model || [];

	const handleSelection = (type) => {
		setSelectedTalpId(type);
		updateOrder({
			...order,
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_cornertype_id: type,
				hmeliorder_corner_type: corner_types.find(t => t.corner_type_szam === type)?.corner_type_name || "",
			},
		});
	};

	const handleSarokChange = (value) => {
		setSarokMagassag(value);
		updateOrder({
			...order,
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_corner_height: value,
				hmeliorder_corner_height_id: corner_heights.find(h => h.corner_height_height === value)?.corner_height_szam || null,
			},
		});
	};

	const handleNext = async () => {
		setLoading(true);

		const updatedOrder = {
			...order,
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_cornertype_id: selectedTalpId,
				hmeliorder_corner_type: corner_types.find(t => t.corner_type_szam === selectedTalpId)?.corner_type_name || "",
				hmeliorder_corner_height: sarokMagassag,
				hmeliorder_corner_height_id: corner_heights.find(h => h.corner_height_height.toString() === sarokMagassag)?.corner_height_szam || null,
			},
		};

		try {
			updateOrder(updatedOrder);
			const result = await saveOrder(updatedOrder);

			if (result?.success !== false) {
				navigate("/TalpRamaSzine");
			} else {
				showErrorToast(result?.message || 'Hiba történt a rendelés mentése során!');
			}
		} catch (err) {
			showErrorToast('Hiba történt a rendelés mentése során: ' + (err?.message || err));
		} finally {
			setLoading(false);
		}
	};

	const handleBack = () => {
		navigate("/OrrForma");
	};

	const canProceed = selectedTalpId > 1 && !!sarokMagassag;

	if (!corner_types.length) {
		return (
			<TablerLayout title="Adja meg a kívánt talp típust és a sarok magasságát!">
				<div className="text-center">
					<div className="alert alert-warning">
						Nincs elérhető talp/sarok opció ehhez a modellhez!
						<br />
						Kérem, lépjen vissza és válasszon másik modellt!
					</div>
				</div>
			</TablerLayout>
		);
	}

	return (
		<TablerLayout title="Adja meg a kívánt talp típust és a sarok magasságát!">
			<div className="row justify-content-center">
				<div className="col-md-10">
					<div className="card-body">
						<div className="row g-4 justify-content-center mb-4">
							{corner_types.map((talp) => (
								<div className="col-12 col-sm-6 col-lg-6" key={talp.corner_type_szam}>
									<button
										type="button"
										className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold
											${talp.disabled 
												? "btn-outline-secondary text-muted border-secondary bg-light" 
												: selectedTalpId === talp.corner_type_szam 
													? "btn-primary" 
													: "btn-outline-primary text-primary border-primary bg-white"}`}
										style={{
											fontSize: 20,
											fontWeight: 600,
											borderWidth: 2,
											minHeight: 100,
											cursor: talp.disabled ? "not-allowed" : "pointer"
										}}
										onClick={() => !talp.disabled && handleSelection(talp.corner_type_szam)}
										disabled={talp.disabled || loading}
										title={talp.disabled ? "Ez a talp/sarok típus nem elérhető ehhez a modellhez" : ""}
									>
										<span>{talp.corner_type_name}</span>
									</button>
								</div>
							))}
						</div>
						{/* Sarok magasság választás */}
						<div className="mt-5">
							<h5 className="text-center mb-4 fw-bold ">Sarok magassága</h5>
							<div className="row g-3 justify-content-center">
								{corner_heights.map((height) => (
									<div className="col-6 col-md-3" key={height.corner_height_szam}>
										<button
											type="button"
											className={`btn w-100 py-3 px-2 shadow-sm rounded-3 fw-bold
												${sarokMagassag === height.corner_height_height.toString() 
													? "btn-primary" 
													: "btn-outline-primary text-primary border-primary bg-white"}`}
											style={{
												fontSize: 18,
												fontWeight: 600,
												borderWidth: 2,
												minHeight: 60,
											}}
											onClick={() => handleSarokChange(height.corner_height_height.toString())}
											disabled={height.disabled || loading}
										>
											{height.corner_height_height} cm
										</button>
									</div>
								))}
							</div>
						</div>
					</div>
					<div className="card-footer d-flex justify-content-between">
						<StepperNavButton side="left" label="Vissza" onClick={handleBack} />
						<StepperNavButton side="right" label="Tovább" onClick={handleNext} disabled={!canProceed || loading} />
					</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default TalpSarok;
